import React from "react";
import test from "../../assets/video/test.mp4";
import styles from "./MainVideo.module.scss";

const VideoContainer: React.FC = React.memo(() => {
	return (
		<div className={styles.container}>
			<video
				autoPlay={true}
				loop={false}
				muted={true}
				preload="auto"
				playsInline
				className={styles.video}
			>
				<source src={test} type="video/mp4" />
			</video>
		</div>
	);
});

export default VideoContainer;
